const emptyArray: any[] = [];

export const mjTextEditorH1Modules = {
  toolbar: {
    container: [
      ['bold', 'italic'],
      ['blockquote'],
      [{ header: [1, 2, 3, false] }],
      [{ font: emptyArray.slice() }],
      [{ align: emptyArray.slice() }],
    ],
  },
};

export const mjTextEditorH2Modules = {
  toolbar: {
    container: [
      ['bold', 'italic'],
      ['blockquote'],
      [{ header: [1, 2, 3, false] }],
      [{ font: emptyArray.slice() }],
      [{ align: emptyArray.slice() }],
    ],
  },
};

export const mjTextEditorH3Modules = {
  toolbar: {
    container: [
      ['bold', 'italic'],
      ['blockquote'],
      [{ header: [1, 2, 3, false] }],
      [{ font: emptyArray.slice() }],
      [{ align: emptyArray.slice() }],
    ],
  },
};

export const mjTextEditorPModules = {
  toolbar: {
    container: [
      ['bold', 'italic'],
      ['blockquote'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link'],
      [{ header: [1, 2, 3, false] }],
      [{ font: emptyArray.slice() }],
      [{ align: emptyArray.slice() }],
    ],
  },
};

export const mjTextEditorFinnModules = {
  toolbar: {
    container: [
      ['bold', 'italic'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link'],
      [{ font: emptyArray.slice() }],
      [{ header: [3, false] }],
    ],
  },
};
